// import { logger } from './debug';

const getTenById = async (getter, ids) => {
  const rest = [...ids];
  const ten = rest.splice(0, 10);
  const data = await Promise.all(ten.map((id) => getter(id, false)));
  if (!rest.length) return data;
  const _data = await getTenById(getter, rest);
  return data.concat(_data);
};

export const getLargeListByID = async (getter, ids) => {
  if (!ids.length) return [];
  const data = await getTenById(getter, ids);
  return data;
};

const getData = async (getter, params, ...args) => {
  const data = await getter(params, ...args);
  // const p = params.page - 1;
  // logger(`obtained ${(p) * (params.page_size || 10) + data.results.length} of ${data.count}`);
  // logger(`obtained ${(p) * 10 + data.results.length} of ${data.count}`);
  if (!data.next) return data.results;
  const page = new URL(data.next).searchParams.get('page');
  const _data = await getData(getter, { ...params, page }, ...args);
  return data.results.concat(_data);
};

/**
 * @param {Object} _params
 * @returns {Promise<object|object[]>}
 */
const getAllPages = async (getter, _params = {}, ...args) => {
  const params = { ..._params, page: _params.page || 1 };
  const data = await getData(getter, params, ...args);
  return data;
};

export default getAllPages;
